/* eslint-disable*/
import axios from '../helpers/Axios'
import store from './../store';
import router from "../router";

export default function setup() {
	// Add Bearer token to all requests
	axios.interceptors.request.use(function (config) {

		var token = store.getters['authmodule/token'];

		if (!token) {

			return store.dispatch('authmodule/updateToken').then(() => {
				token = store.getters['authmodule/token'];

				if (token) {
					config.headers.Authorization = `Bearer ${token}`;
				}

				return config;
			});

		} else {

			if (token) {
				config.headers.Authorization = `Bearer ${token}`;
			}
			return config;
		}
	}, function (err) {
		console.log(err);
		return Promise.reject(err);
	});

	// Intercept all 401s and redirect to login
	axios.interceptors.response.use((response) => {
		return response;
	}, function (error) {
		// Do something with response error
		 if (error.response.status === 401) {
			console.log('unauthorized, logging out ...', typeof window !== 'undefined');

			store.dispatch('authmodule/logout')

			router.push('/login');
		}
		return Promise.reject(error.response);
	});
	
}
